import { create } from 'zustand';

type ToastType = 'success' | 'error' | 'info';

interface Toast {
  type: ToastType;
  message: string;
}

interface ToastStore {
  toast: Toast | null;
  showToast: (toast: Toast) => void;
  hideToast: () => void;
}

export const useToast = create<ToastStore>((set) => ({
  toast: null,
  showToast: (toast: Toast) => {
    set({ toast });
    setTimeout(() => {
      set({ toast: null });
    }, 5000);
  },
  hideToast: () => set({ toast: null })
}));